module.exports = __webpack_public_path__ + "img/fund_img4.bf539671.png";